import { redirect } from "@tanstack/react-router";

export const browseDogsAdoptRoute = {
    beforeLoad: () => {
        throw redirect({ to: "/", statusCode: 301 });
    },
};

export const browseDogsFeedRoute = {
    beforeLoad: ({ location }: { location: { search: object } }) => {
        throw redirect({
            to: "/discover",
            search: { ...location.search, source: "feed" as const },
            replace: true,
        });
    },
};

export const browseDogsDoomscrollRoute = {
    beforeLoad: ({ location }: { location: { search: object } }) => {
        throw redirect({
            to: "/discover",
            search: location.search,
            replace: true,
        });
    },
};
